import React, { FC } from 'react';
import Comment from './Comment';
import { motion } from 'framer-motion';
import { fadein, item } from '../../../../Shared/Motion';
import { CommentDto } from './AnnotationComments.types';

type Props = {
  comments: CommentDto[];
  parentIds: string[];
  addedFailed: boolean;
  addedSuccessfully: boolean;
  onAddComment: (parentIds: string[], message: string) => void;
  onDeleteComment: (parentIds: string[], id: string) => void;
  onEditComment: (parentIds: string[], message: string, id: string) => void;
};

const Comments: FC<Props> = ({ comments, parentIds, addedFailed, addedSuccessfully, onAddComment, onDeleteComment, onEditComment }) => {
  return (
    <motion.div initial='hidden' animate='visible' variants={fadein}>
      {comments.map(comment => (
        <motion.div key={comment.id} variants={item}>
          <Comment
            addedFailed={addedFailed}
            addedSuccessfully={addedSuccessfully}
            parentIds={parentIds}
            comment={comment}
            onAddComment={onAddComment}
            onDeleteComment={onDeleteComment}
            onEditComment={onEditComment}
          />
        </motion.div>
      ))}
    </motion.div>
  );
};

export default Comments;
